var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCvssScore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6668 7.5849C11.6668 10.5016 9.62516 11.9599 7.1985 12.8057C7.07142 12.8488 6.93339 12.8467 6.80766 12.7999C4.37516 11.9599 2.3335 10.5016 2.3335 7.5849V3.50156C2.3335 3.34685 2.39495 3.19848 2.50435 3.08909C2.61375 2.97969 2.76212 2.91823 2.91683 2.91823C4.0835 2.91823 5.54183 2.21823 6.55683 1.33156C6.68041 1.22598 6.83762 1.16797 7.00016 1.16797C7.16271 1.16797 7.31991 1.22598 7.4435 1.33156C8.46433 2.22406 9.91683 2.91823 11.0835 2.91823C11.2382 2.91823 11.3866 2.97969 11.496 3.08909C11.6054 3.19848 11.6668 3.34685 11.6668 3.50156V7.5849Z",
    stroke: "#58CC02",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCvssScore);
export default __webpack_public_path__ + "static/media/cvss_score.e228b8ebb4688959299cd2db77bfbbe0.svg";
export { ForwardRef as ReactComponent };